import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left fs-1x p-0" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.to,
    class: _normalizeClass(["btn btn-sm", _ctx.className])
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(" " + _toDisplayString(_ctx.t("back")), 1)
    ]),
    _: 1
  }, 8, ["to", "class"]))
}